'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require('_');

var _Immutable = require('Immutable');

var _hublyticsEventClasses = require('event-tracking-tools/hublytics/hublyticsEventClasses');

var _hublyticsEventClasses2 = _interopRequireDefault(_hublyticsEventClasses);

var _eventPropTypes = require('event-tracking-tools/events/eventPropTypes');

var _eventPropTypes2 = _interopRequireDefault(_eventPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductEventRecord = (0, _Immutable.Record)({
  // Event-level strict check. If true, events will fail if they don't match.
  // If false, the events will throw a warning to the console.
  useStrict: false,

  // The name of the event as it will appear in hublytics/amplitude
  name: null,

  // A string that specifies the event's class grouping
  type: null,

  // Validation for the top-level record props.
  // Because the record sets default values and drops unexpected props,
  // this is needed as a "hidden" property.
  __propTypes__: {
    name: _eventPropTypes2.default.STRING,
    type: _eventPropTypes2.default.ONE_OF((0, _.values)(_hublyticsEventClasses2.default))
  },

  // Arbitrary propTypes that can have a validator or default value.
  // You can also specify some types using eventPropTypes
  // otherwise they always default to eventPropTypes.REQUIRED
  propTypes: {}

}, 'ProductEventRecord');

ProductEventRecord.debugName = 'ProductEventRecord';

exports.default = ProductEventRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/records/ProductEventRecord.js
// module id = 541
// module chunks = 0